module.exports = __webpack_public_path__ + "static/media/geolocalizacion-Brios-Mobile.70a46c0c.webp";